module.exports = __webpack_public_path__ + "static/media/movements.fbbc75e4.svg";